/**
 * Токен сессии для встроенного режима Bitrix24 (Т20).
 *
 * Браузер может не сохранить cookie во встроенной рамке чужого сайта. Сервер после входа
 * передаёт токен во фрагменте адреса (`#gw_token=…`) — фрагмент не уходит на сервер и не пишется
 * в журналы. Страница сразу убирает его из адреса и держит токен в sessionStorage вкладки,
 * чтобы вход пережил перезагрузку рамки.
 */

const STORAGE_KEY = 'gw_token';
const TOKEN_PATTERN = /^[A-Za-z0-9_-]{20,128}$/;
let memoryToken: string | null = null;

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/** Забирает токен из адреса страницы. Вызывать один раз до первого запроса к API. */
export function captureTokenFromUrl(): void {
  const match = /(?:^#|&)gw_token=([^&]+)/.exec(window.location.hash);
  if (!match?.[1]) return;
  const token = decodeURIComponent(match[1]);
  const rest = window.location.hash.replace(match[0], '').replace(/^#&?/, '');
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${window.location.search}${rest ? `#${rest}` : ''}`,
  );
  if (!TOKEN_PATTERN.test(token)) return;
  memoryToken = token;
  try {
    storage()?.setItem(STORAGE_KEY, token);
  } catch {
    // Хранилище недоступно: токен живёт только в памяти до перезагрузки.
  }
}

export function getSessionToken(): string | null {
  if (memoryToken) return memoryToken;
  try {
    return storage()?.getItem(STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

export function clearSessionToken(): void {
  memoryToken = null;
  try {
    storage()?.removeItem(STORAGE_KEY);
  } catch {
    // нечего очищать
  }
}
